import {
  DASHBOARD_USER_LIST,
  DASHBOARD_ORDER_USER_LIST,
  DASHBOARD_TOTAL_USERS,
  USER_CATEGORY_LIST,
  DASHBOARD_USER_MODAL,
  DASHBOARD_USER_EXPORT_MODAL,
  DASHBOARD_USER_CATEGORY_MODAL,
  ADDEDIT_USER_CATEGORY,
  IMPORT_USER_MODAL,
  DASHBOARD_USER,
  USER_EVENT_DETAILS,
  USER_BULK_UPLOAD_LEFT,
  DASHBOARD_USER_CATEGORY_WISE,
  EVENTBRITE_KEYS,
  EVENT_POLICY_TYPE_MODAL,
  USER_DOWNLOAD_INFO,
  DASHBOARD_USER_RESET_PASSWORD_MODAL,
  DASHBOARD_TOTAL_NOOF_USERSHITS,
  DASHBOARD_USERS_COUNT,
  DASHBOARD_USER_GROUP_MANAGE_MODAL,
  MANAGE_USERGROUP_USER_LIST,
  PASSCODE_EMAIL,
  DASHBOARD_ALL_USER_LIST, // for community backup support
  EVENT_DEFAULT_APPUSER_CHECKOUT_FORM,
  APPUSER_COUNTING_NUMBERS,
  APPUSER_NOT_LOGIN_COUNT,
  ANALYTICS_VIEW_MODAL,
  USER_SCAN_DATA,
  APPUSER_TOTAL_NOT_LOGIN_COUNT,
} from "DashboardUserAction";

//Store Total Number of user hits on app
export var DashboardTotalNoOfUsersHits = (state = {}, action) => {
  if (action.type === DASHBOARD_TOTAL_NOOF_USERSHITS) {
    return action.payload;
  }
  return state;
};

export var DashboardTotalUsers = (state = {}, action) => {
  if (action.type === DASHBOARD_TOTAL_USERS) {
    return action.payload;
  }
  return state;
};

export var bulkUserUplodingLeft = (state = {}, action) => {
  if (action.type === USER_BULK_UPLOAD_LEFT) {
    return action.payload;
  }
  return state;
};

export var DashboardUserList = (state = {}, action) => {
  if (action.type === DASHBOARD_USER_LIST) {
    return action.payload;
  }
  return state;
};
export var UserOrderByDateCreated = (state = {}, action) => {
  if (action.type === DASHBOARD_ORDER_USER_LIST) {
    return action.payload;
  }
  return state;
};

export var UserCategoryList = (state = {}, action) => {
  if (action.type === USER_CATEGORY_LIST) {
    return action.payload;
  }
  return state;
};

export var passcodeEmail = (state = {}, action) => {
  if (action.type === PASSCODE_EMAIL) {
    return action.payload;
  }
  return state;
};

export var DashboardUserCategoryWise = (state = {}, action) => {
  if (action.type === DASHBOARD_USER_CATEGORY_WISE) {
    return action.payload;
  }
  return state;
};

export var EventbriteKeys = (state = {}, action) => {
  if (action.type === EVENTBRITE_KEYS) {
    return action.payload;
  }
  return state;
};

export var userEventDetails = (state = {}, action) => {
  if (action.type === USER_EVENT_DETAILS) {
    return action.payload;
  }
  return state;
};

export var ShowDashboardUserModal = (state = false, action) => {
  if (action.type === DASHBOARD_USER_MODAL) {
    return action.payload;
  }
  return state;
};

export var ShowDashboardUserCategoryModal = (state = false, action) => {
  if (action.type === DASHBOARD_USER_CATEGORY_MODAL) {
    return action.payload;
  }
  return state;
};

export var addEditUserCategory = (state = {}, action) => {
  if (action.type === ADDEDIT_USER_CATEGORY) {
    return action.payload;
  }
  return state;
};

export var ShowDashboardUserExportModal = (
  state = { show: false, key: "" },
  action
) => {
  if (action.type === DASHBOARD_USER_EXPORT_MODAL) {
    return action.payload;
  }
  return state;
};

export var ShowImportUserModal = (state = false, action) => {
  if (action.type === IMPORT_USER_MODAL) {
    return action.payload;
  }
  return state;
};

export var DashboardUser = (state = {}, action) => {
  if (action.type === DASHBOARD_USER) {
    return action.payload;
  }
  return state;
};

export var ShowEventPolicyTypeModal = (state = false, action) => {
  if (action.type === EVENT_POLICY_TYPE_MODAL) {
    return action.payload;
  }
  return state;
};

export var DownloadUser = (state = [], action) => {
  if (action.type === USER_DOWNLOAD_INFO) {
    return action.payload;
  }
  return state;
};

export var userRestPasswordModal = (state = {}, action) => {
  if (action.type === DASHBOARD_USER_RESET_PASSWORD_MODAL) {
    return action.payload;
  }
  return state;
};

export var totalNumberOfUsers = (state = {}, action) => {
  if (action.type === DASHBOARD_USERS_COUNT) {
    return action.payload;
  }
  return state;
};

export var appuserGroupManageModal = (state = {}, action) => {
  if (action.type === DASHBOARD_USER_GROUP_MANAGE_MODAL) {
    return action.payload;
  }
  return state;
};
export var appUserListGroupManage = (state = {}, action) => {
  if (action.type === MANAGE_USERGROUP_USER_LIST) {
    return action.payload;
  }
  return state;
};

export var TotalUsers = (state = {}, action) => {
  if (action.type === DASHBOARD_ALL_USER_LIST) {
    return action.payload;
  }
  return state;
};

export var eventDefautUserCheckoutForm = (state = {}, action) => {
  if (action.type === EVENT_DEFAULT_APPUSER_CHECKOUT_FORM) {
    return action.payload;
  }
  return state;
};

export var appuserCounts = (state = {}, action) => {
  if (action.type === APPUSER_COUNTING_NUMBERS) {
    return action.payload;
  }
  return state;
};

export var usernotLoginCount = (state = {}, action) => {
  if (action.type === APPUSER_NOT_LOGIN_COUNT) {
    return action.payload;
  }
  return state;
};

export var viewAnalyticsData = (state = {}, action) => {
  if (action.type === ANALYTICS_VIEW_MODAL) {
    return action.payload;
  }
  return state;
};

export var userScanData = (state = {}, action) => {
  if (action.type === USER_SCAN_DATA) {
    return action.payload;
  }
  return state;
};

export var totalUsernotLoginCount = (state = {}, action) => {
  if (action.type === APPUSER_TOTAL_NOT_LOGIN_COUNT) {
    return action.payload;
  }
  return state;
};
